//
// The IDE isn't happy with this ipaddr.js import in Typescript for some reason, but the build is.
// Suppressing it causes the build to fail and the IDE to be happy.
//
// I've isolated it in a single file to keep it as JavaScript, where both the
// IDE and the build are okay with it.
//
import ipaddr from "ipaddr.js";

export function isValidIpAddress(value) {
    return ipaddr.isValid(value) || ipaddr.isValidCIDR(value);
}
